<script>
  export let innings;

  const INNINGS = 9;
</script>

<div class='game-score-legend'>
  <div class='game-score-legend-team'/>

  <div class='game-score-legend-innings game-score-legend-innings-{innings}'>
    {#each Array(innings) as _, inning}
      <div class='game-score-legend-innings-inning'> {inning + 1} </div>
    {/each}

    {#if innings > INNINGS}
      <div class='game-score-legend-innings-extra'> X </div>
    {/if}
  </div>

  <div class='game-score-legend-totals'>
    <div class='game-score-legend-totals-r'> R </div>

    <div class='game-score-legend-totals-h'> H </div>

    <div class='game-score-legend-totals-e'> E </div>

    <div class='game-score-legend-totals-lob'> LOB </div>
  </div>
</div>

<style>
  .game-score-legend {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 50px;

    height: 15px;

    padding: 0px 20px;

    text-transform: uppercase;

    font-size: 10px;
    font-weight: 550;

    letter-spacing: 1px;

    color: var(--grey-5);
  }

  .game-score-legend-team {
    width: 150px;
  }

  .game-score-legend-innings {
    display: flex;
    gap: 10px;
  }

  .game-score-legend-innings-inning {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  .game-score-legend-innings-extra {
    display: none;
    justify-content: center;

    width: 30px;
  }

  .game-score-legend-totals {
    display: flex;
    gap: 10px;
  }

  .game-score-legend-totals-r {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  .game-score-legend-totals-h {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  .game-score-legend-totals-e {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  .game-score-legend-totals-lob {
    display: flex;
    justify-content: center;

    width: 30px;
  }

  :global(body.dark) .game-score-legend {
    color: var(--grey-6);
  }

  @media only screen and (max-width: 1100px) {
    :not(.game-score-legend-innings-10) > .game-score-legend-innings-inning:nth-child(n + 10) {
      display: none;
    }

    :not(.game-score-legend-innings-10) > .game-score-legend-innings-extra {
      display: flex;
    }
  }

  @media only screen and (max-width: 950px) {
    .game-score-legend-innings {
      display: none;
    }
  }

  @media only screen and (max-width: 500px) {
    .game-score-legend-totals-lob {
      display: none;
    }
  }

  @media only screen and (max-width: 450px) {
    .game-score-legend-team {
      width: 75px;
    }
  }
</style>
